var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_4253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.125 21.5938V1.90625C28.125 1.12695 27.498 0.5 26.7188 0.5H7.5C4.39453 0.5 1.875 3.01953 1.875 6.125V24.875C1.875 27.9805 4.39453 30.5 7.5 30.5H26.7188C27.498 30.5 28.125 29.873 28.125 29.0938V28.1562C28.125 27.7168 27.9199 27.3184 27.6035 27.0605C27.3574 26.1582 27.3574 23.5859 27.6035 22.6836C27.9199 22.4316 28.125 22.0332 28.125 21.5938ZM9.375 8.35156C9.375 8.1582 9.5332 8 9.72656 8H22.1484C22.3418 8 22.5 8.1582 22.5 8.35156V9.52344C22.5 9.7168 22.3418 9.875 22.1484 9.875H9.72656C9.5332 9.875 9.375 9.7168 9.375 9.52344V8.35156ZM9.375 12.1016C9.375 11.9082 9.5332 11.75 9.72656 11.75H22.1484C22.3418 11.75 22.5 11.9082 22.5 12.1016V13.2734C22.5 13.4668 22.3418 13.625 22.1484 13.625H9.72656C9.5332 13.625 9.375 13.4668 9.375 13.2734V12.1016ZM24.2227 26.75H7.5C6.46289 26.75 5.625 25.9121 5.625 24.875C5.625 23.8437 6.46875 23 7.5 23H24.2227C24.1113 24.002 24.1113 25.748 24.2227 26.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_4253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogs);
export default __webpack_public_path__ + "static/media/blogs.fce18d64e805aaee22f50bf1452a920b.svg";
export { ForwardRef as ReactComponent };